var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"sidebar-item",attrs:{"to":{path: this.link}}},[_c('span',{style:({backgroundImage: _vm.path})}),_c('h3',[_vm._v(_vm._s(this.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }